import { aproveOrders, aproveOrdersBN, editOrder,deleteOrderDetail, displayPDFOrder,checkProduct,sectionOrderDetail,consultFormula,remisionOrderDetail,processFormula,groupForClient, displayPDFOrderId } from '../../_services/order.service';

const DELETED_STATE = 'DELE';

export const aproverOrdersEvent = async (dataUploaded, selectedOptions,in_process) => {
    let data = [...dataUploaded];
    data = data.filter((d) => d.checked === 1);
    let value_selects=[...selectedOptions];
    if (data.length === 0) throw new Error('No hay órdenes seleccionadas');
    let toAproveUUID = [];
    let toAproveUUIDProducts=[]; 
    data.forEach((element) => {
        let count=0;
        let defe=0;
        value_selects.forEach((s) => {
            let comp=s.split("//");
            if(comp[1] === element.uuid){  
                if(comp[0] !== 'all-defect-i'){
                    if (comp[0] === 'DEFE'){defe++;}
                    count++;
                    toAproveUUIDProducts.push(s);
                }}})
        toAproveUUID.push(element.uuid);
    });
    let body = {
      toAproveUUID,
      toAproveJSON: JSON.stringify(data),
      toAproveUUIDProducts,
      in_process
    };
    let res = await aproveOrders(body);
    if (!res.ok) throw new Error(res.error);
    return res;
};

export const aproverOrdersBNEvent = async (dataUploaded, selectedOptions,in_process) => {
    let data = [...dataUploaded];
    data = data.filter((d) => d.checked === 1);
    let value_selects=[...selectedOptions];
    if (data.length === 0) throw new Error('No hay órdenes seleccionadas');
    let toAproveUUID = [];
    let toAproveUUIDProducts=[]; 
    data.forEach((element) => {
        let count=0;
        let defe=0;
        value_selects.forEach((s) => {
            let comp=s.split("//");
            if(comp[1] === element.uuid){  
                if(comp[0] !== 'all-defect-i'){
                    if (comp[0] === 'DEFE'){defe++;}
                    count++;
                    toAproveUUIDProducts.push(s);
                }}})
        toAproveUUID.push(element.uuid);
    });
    let body = {
      toAproveUUID,
      toAproveJSON: JSON.stringify(data),
      toAproveUUIDProducts,
      in_process
    };
    let res = await aproveOrdersBN(body);
    if (!res.ok) throw new Error(res.error);
    return res;
};
  

export const deleteOrdersEvent = async (uuid) => {
    if(! uuid) throw new Error('No hay orden especificada');
    let body = {
        uuid,
        state: DELETED_STATE
    }    
    let res = await editOrder(body);
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const remisionOrdersEvent = async (selectedProductsRight,selectedClientsArray) => {
    if(! selectedProductsRight) throw new Error('No hay ordenes especificadas');
    let body = {
        selectedProductsRight,
        selectedClientsArray
    }    
    let res = await remisionOrderDetail(body);
    //if(! res.ok) throw new Error(res.error);
    return res;
}

export const sectionOrdersEvent = async (orderDetail,quantity_section,quantity_order,order,in_process) => {
    if(! orderDetail) throw new Error('No hay producto especificado');
    let body = {
        orderDetail,
        quantity_order,
        quantity_section,
        order,
        in_process
        
    }    
    let res = await sectionOrderDetail(body);
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const displayPDFOrderEvent = async (order) => {
    if(! order) throw new Error('No hay orden especificada');
    let res = await displayPDFOrder(order);
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const displayPDFOrderIdEvent = async (id) => {
    let res = await displayPDFOrderId(id);
    if(! res.ok) throw new Error(res.error);
    return res;
}


export const consultFormulaEvent = async (orderDetail) => {
    if(! orderDetail) throw new Error('No hay producto especificado');
    let res = await consultFormula(orderDetail);
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const processFormulaEvent = async (orderDetail,data_formula) => {
    let body={
        orderDetail,
        data_formula
    }
    if(! orderDetail) throw new Error('No hay producto especificado');
    let res = await processFormula(body);
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const deleteOrderDetailEvent = async (uuid) => {
    if(!uuid) throw new Error('No hay producto especificado');
    let body = {
        uuid,
        state: 'DELE'
    }    
    let res = await deleteOrderDetail(body);
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const confirmDeleteOrderDetailEvent = async (uuid) => {
    if(!uuid) throw new Error('No hay producto especificado');
    let body = {
        uuid,
        state: 'DELE'
    }    
    let res = await deleteOrderDetail(body);
    if(! res.ok) throw new Error(res.error);
    return res;
}


//metodos de checkeo de pistola de barras
export const checkProductEvent = async (uuid_detail,check) => {    
    let res = await checkProduct(uuid_detail,check);
    return res;
}


